<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex md12 align-self-center text-center class="fontts">
        <v-layout wrap justify-center>
          <v-flex md12 px-12 pt-12>
            <v-layout wrap justify-center text-center v-if="observation > ''">
              <v-flex
                style="background-color: #86ab5ef3; opacity: 1"
                sm12
                md12
                align-self-start
              >
                <span class="title3">Turtle checklist</span>
              </v-flex>
              <v-flex sm12 md12 align-self-start text-left pl-3 pt-6>
                <span class="title3">List of sightings</span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md3 v-for="(item, i) in observation" :key="i" pa-2>
                <v-card height="300px">
                  <!-- <v-img v-if="item.image !==''"
                                :src="mediaURL + item.image"
                                height="84px"
                                width="120px"
                                cover
                              >


                </v-img> -->
                  <v-img
                    v-if="item.image != null"
                    height="190px"
                    cover
                    :src="mediaURL + item.image"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color=" #FDAC53"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-img
                    v-if="item.image == null"
                    height="190px"
                    cover
                    src="../../assets/logos/sample.png"
                  >
                  </v-img>

                  <v-layout wrap>
                    <v-flex
                      xs12
                      pt-5
                      style="
                        font-family: poppins-bold;
                        color: black;
                        font-size: 18px;
                      "
                    >
                      <router-link
                        class="routerlink"
                        :to="'/details/' + item._id"
                        style="color: black; text-transform: uppercase"
                      >
                        <span class="text"> {{ item.turtle.name }}</span>
                      </router-link></v-flex
                    >
                    <v-flex xs12>Place: {{ item.state }}</v-flex>
                    <v-flex xs12>{{ DateFormatted(item.createddate) }}</v-flex>
                    <v-flex xs6></v-flex>
                  </v-layout>
                  <!-- <v-card-title>{{item.turtle.name}}</v-card-title>
              <v-card-text> {{ item.state }}</v-card-text>
              <v-card-text> {{ DateFormatted(item.createddate) }}</v-card-text> -->
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start v-if="rescue !== ''" pl-3 pt-5>
              <v-flex md12 align-self-start text-left>
                <span class="title3">List of rescues</span>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex md3 v-for="(item, i) in rescue" :key="i" pa-2>
                <v-card
                  :height="$vuetify.breakpoint.name == 'xl' ? '300px' : '300px'"
                >
                  <!-- <v-img v-if="item.image !==''"
                                :src="mediaURL + item.image"
                                height="84px"
                                width="120px"
                                cover
                              >

                </v-img> -->
                  <v-img
                    v-if="item.image != null"
                    height="190px"
                    :src="mediaURL + item.image"
                  >
                  </v-img>
                  <v-img
                    v-if="item.image == null"
                    height="190px"
                    src="../../assets/logos/sample.png"
                  >
                  </v-img>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      pt-5
                      style="
                        font-family: poppins-bold;
                        color: black;
                        font-size: 18px;
                      "
                      ><router-link
                        class="routerlink"
                        :to="'/details/' + item._id"
                        style="color: black; text-transform: uppercase"
                      >
                        <span class="text">
                          {{ item.turtle.name }}</span
                        ></router-link
                      ></v-flex
                    >
                    <v-flex xs12> Place :{{ item.state }}</v-flex>
                    <v-flex xs12>{{ DateFormatted(item.createddate) }}</v-flex>

                    <v-flex xs6></v-flex>
                  </v-layout>
                  <!-- <v-card-title>{{item.turtle.name}}</v-card-title>
              <v-card-text> {{ item.state }}</v-card-text>
              <v-card-text> {{ DateFormatted(item.createddate) }}</v-card-text> -->
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex>
                <v-layout wrap justify-center text-center>
                  <v-flex
                    xs12
                    text-center
                    class="title3"
                    style="background-color: #86ab5ef3; opacity: 1"
                  >
                    <span class="main">Analytics</span>
                  </v-flex>
                  <v-flex md6 v-if="observe.length > 0" xs12 pt-2>
                    <apexchart
                      width="100%"
                      height="600px"
                      type="bar"
                      :options="chartOptions1"
                      :series="series"
                    ></apexchart>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      observe: [],
      series: [
        {
          name: "",
          data: [],
        },
      ],
      chartOptions1: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      graph: [],
      reportData: [],
      no_of_observations: "",
      no_of_rescues: "",
      no_of_sightings: "",
      // speciess: [],
      Sightings: {
        state: "",
        date: "",
        img: "",
      },
      observation: [],
      rescue: [],
    };
  },
  mounted() {
    this.getReport();
    this.graph1();
  },
  methods: {
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y") : "";
    },
    getReport() {
      axios({
        method: "GET",
        url: "report/mine",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.reportData = response.data.data;
          // this.no_of_sightings = response.data.data.length
          // var count_res = 0,
          //   count_observ = 0;
          var Species = [];
          var speciesCount = 0;
          var listItems = response.data.data;
          for (var i = 0; i < listItems.length; i++) {
            if (listItems[i].purpose == "observation")
              this.observation.push(listItems[i]);
            if (listItems[i].purpose == "rescue")
              this.rescue.push(listItems[i]);
            if (!Species.includes(listItems[i].turtle.name)) {
              Species.push(listItems[i].turtle.name);
              speciesCount++;
            }
            this.no_of_sightings = speciesCount;
          }

          console.log("observation is=", this.observation);
        }
      });
    },
    graph1() {
      axios({
        method: "GET",
        url: "DashBoard/getgraph",
      }).then((response) => {
        if (response.data.status) {
          this.observe = response.data.data;
          for (var k = 0; k < this.observe.length; k++) {
            this.chartOptions1.xaxis.categories.push(this.observe[k].month);
            this.series[0].data.push(this.observe[k].count);
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>